module.exports = __webpack_public_path__ + "img/header-memoireRingsRosegold@2x.79916c5.jpg";